import {
  useDownloadAllZipHistoryHomepass,
  useExportHistoryHomepass,
  useHistoryUpdateHomepass,
} from "@/api/history-update-homepass";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  DefaultButton,
  DownloadButton,
  PrintButton,
} from "@/components/ui/button";
import { formatDateTime } from "@/utils/helper/formatDate";
import { swalErrorDefault } from "@/utils/lib/swal";
import { useState } from "react";
import { useParams } from "react-router-dom";

export default function HistoryProfileHomepass() {
  const { id } = useParams();
  const { data } = useHistoryUpdateHomepass({ rfsId: id });
  const [downloadId, setIsDownloadingId] = useState<string | null>(null);

  const { mutate: exportHistoryHomepass, isPending } =
    useExportHistoryHomepass();
  const { mutate: downloadZip, isPending: isPendingAllZips } =
    useDownloadAllZipHistoryHomepass();

  function handleExport() {
    if (data && data.length > 0) {
      exportHistoryHomepass(
        { ids: data.map((item) => item.id).join(",") },
        {
          onError: () => {
            swalErrorDefault.fire({
              text: "Failed to export history update profile homepass",
            });
          },
        },
      );
    }
  }

  function handleDownloadAllZip() {
    if (data && data.length > 0) {
      setIsDownloadingId("all");
      downloadZip(
        { ids: data.map((item) => item.id).join(",") },
        {
          onSuccess: () => {
            setIsDownloadingId(null);
          },
          onError: () => {
            setIsDownloadingId(null);
          },
        },
      );
    }
  }

  function handleDownloadZip(id: string) {
    if (id) {
      setIsDownloadingId(id);
      downloadZip(
        { ids: id },
        {
          onSuccess: () => {
            setIsDownloadingId(null);
          },
          onError: () => {
            setIsDownloadingId(null);
          },
        },
      );
    }
  }

  return (
    <div className="mt-10">
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value={"updateProfileHomepass"}>
          <AccordionTrigger>
            <span className="text-xl font-semibold leading-none tracking-tight">
              Log History Update Profile Homepass
            </span>
          </AccordionTrigger>
          <AccordionContent className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <PrintButton onClick={handleExport} loading={isPending}>
                  Export to Excel
                </PrintButton>
              </div>
              <div>
                <DownloadButton
                  onClick={handleDownloadAllZip}
                  loading={isPendingAllZips && downloadId === "all"}
                >
                  Download All ABD.kmz & HPTAR.xlsx
                </DownloadButton>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full table-auto border">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Vendor
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Cluster ID
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP APD
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP HOME
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP HOME-BIZ
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP RFS
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP INVALID
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP ADD
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP NEED_SURVEY
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      Total HP NO NEED_SURVEY
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      UPDATE STATUS
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      UPDATE BY
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      UPDATE DATE
                    </th>
                    <th className="w-min whitespace-nowrap  p-4 text-left text-sm font-medium">
                      DOWNLOAD ABD.KMZ & HPTAR.xlsx
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((history) => (
                    <tr className="border-y" key={history.id}>
                      <td className=" whitespace-nowrap p-4 text-sm">
                        {history.vendor.company ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.clusterId ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalHpApd ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalResidenceHomepass ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalBizzHomepass ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalHpRfs ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalHomepassInvalid ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalHomepassAdditional ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalNeedSurvey ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.totalNoNeedSurvey ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">{history.status ?? "-"}</td>
                      <td className=" p-4 text-sm">
                        {history.updatedByName ?? "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        {history.updatedDate
                          ? formatDateTime(history.updatedDate)
                          : "-"}
                      </td>
                      <td className=" p-4 text-sm">
                        <DefaultButton
                          onClick={() => handleDownloadZip(history.id)}
                          mood="axiata-blue-link"
                          loading={
                            isPendingAllZips && downloadId === history.id
                          }
                        >
                          Download
                        </DefaultButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
